import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { addAccessedCode } from '../lib/tripHistory';

export default function JoinByQuery() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const code = (params.get('code') || '').trim().toUpperCase();

  useEffect(() => {
    if (code) {
      addAccessedCode(code);
      navigate(`/trip/${code}`, { replace: true });
    } else {
      navigate('/home', { replace: true });
    }
  }, [code, navigate]);

  return null;
}
